export var PRODUCT_CATALOG_LIMIT = 1000;
export var PRODUCT_PLANS_LIMIT = 100;
export var PRODUCT_DEFAULT_PAGE = 1;
export var PRODUCT_ALERT_AUTO_CLOSE = 10000;
export var PRODUCT_CURRENCIES_ORDER_BY = "name";
export var PRODUCT_CURRENCIES_ORDER_DIR = "ASC";
export var PRODUCT_CAMPAIGN_PROJECT_STATUS = 1;
export var PANEL_RECURRENCE = 1;
export var PANEL_PLANS = 3;
export var AVATAR_ENTITY_PROJECT = "Project";
export var DELETE_ENTITY_RECURRENCE = "PaymentModeProjectEntity";
export var DELETE_ENTITY_PAYMENT_MODE = "AccountTypeProjectEntity";
export var CATALOG_TYPE_PAYMENT_MODE = "CATALOG_PAYMENT_MODE";
export var CATALOG_TYPE_ACCOUNT_TYPE = "CATALOG_ACCOUNT_TYPE";
export var ACTION_FLAG_NAMES = [
    "afy-plan-range-age",
    "afy-confirm-data-show-insured",
    "afy-confirm-data-add-insured",
    "afy-confirm-data-show-beneficiary",
    "afy-confirm-data-add-beneficiary",
    "afy-validate-customer-default-country",
];
export var ACTION_FLAG_DEFAULT_VALUE = "false";
export var ACTION_FLAG_ACTIVE_VALUE = "true";
export var ACTION_FLAG_ACTIVE_LABEL = "Activo";
export var ACTION_FLAG_INACTIVE_LABEL = "Inactivo";
export var LOADING_TEXT = "Cargando...";
export var UPDATING_TEXT = "Actualizando";
export var ALERT_CREATE_CAMPAIGN = "Para continuar, ahora cree una campaña";
export var ALERT_ADD_RECURRENCE = "Para continuar, ahora Agregue una recurrencia de pago";
export var ALERT_ADD_PAYMENT_MODE = "Para continuar, ahora Agregue un modo de pago";
export var ALERT_ADD_PLANS = "Para continuar, ahora Agregue los planes";
export var TOAST_PRODUCT_CREATED = "Producto creado con éxito.";
export var TOAST_PRODUCT_UPDATED = "Producto actualizado con éxito.";
export var TOAST_CAMPAIGN_CREATED = "Campaña creada con éxito.";
export var TOAST_CAMPAIGN_UPDATED = "Campaña actualizada con éxito.";
export var TOAST_RECURRENCE_ADDED = "Recurrencia de pago agregada con éxito.";
export var TOAST_PAYMENT_MODE_ADDED = "Modo de pago agregado con éxito.";
export var DELETE_TITLE_RECURRENCE = "recurrencia de pago";
export var DELETE_TITLE_PAYMENT_MODE = "modo de pago";
export var deleteSubTitleRecurrence = function (description) {
    return "la recurrencia de pago ".concat(description === null || description === void 0 ? void 0 : description.toLowerCase());
};
export var deleteSubTitlePaymentMode = function (description) {
    return "el modo de pago ".concat(description === null || description === void 0 ? void 0 : description.toLowerCase());
};
export var MODAL_DELETE_TITLE = "Eliminar";
export var modalDeleteQuestion = function (subTitle) {
    return "\u00BFEst\u00E1 seguro que desea eliminar ".concat(subTitle, "?");
};
export var MODAL_DELETE_CANCEL_LABEL = "No";
export var MODAL_DELETE_CONFIRM_LABEL = "Si, eliminar";
export var PRODUCT_PERMISSIONS = {
    create: true,
    read: true,
    update: true,
    delete: true,
};
export var routePlanCreation = function (productId, planId) {
    return planId
        ? "/plan-creation/".concat(productId, "/").concat(planId)
        : "/plan-creation/".concat(productId);
};
